import { LegacyCard, Page, Button, LegacyStack } from '@shopify/polaris';
import { useParams } from 'react-router';
import { postSell } from '../../../services/sellsService';
import { NewSellModal } from '../../UI/Sells/NewSellModal';
import SellsList from '../../UI/Sells/SellsList';
import ToastContext from '../../../context/ToastContext';
import { SET_ERROR, SET_OK } from '../../../context/ToastReducer';
import { useContext } from 'react';
import { useRef } from 'react';
import { checkPermission } from '../../../services/permissionsService';

const Sells = () => {
  const { page } = useParams();
  const [, dispatchToast] = useContext(ToastContext);
  const newSellModal = useRef();

  const returnMatch = window.location.search.match(/\??r=(.+)&?/);
  const returnUrl = returnMatch && returnMatch.length > 1 ? window.atob(returnMatch[1]) : null;

  const createNewSell = (form) => {
    return postSell(form)
      .then((r) => {
        const id = r.data.id;
        dispatchToast({ type: SET_OK, payload: r.data });
        window.location.href = `/sells/${id}/?r=${window.btoa(window.location.pathname + window.location.search)}`;
      })
      .catch((e) => {
        dispatchToast({ type: SET_ERROR, payload: e.response.data });
        throw new Error(e.response.data);
      });
  };

  return <>
    <Page
      title="Ventas"
      primaryAction={
        <LegacyStack>
          {checkPermission('SELL:CREATE') && <Button url="/sells/file">Añadir fichero EPH</Button>}
          {checkPermission('SELL:CREATE') && <NewSellModal ref={newSellModal} onAddSell={(e) => createNewSell(e)} />}
        </LegacyStack>
      }
      divider
      backAction={returnUrl && { content: 'Volver', url: returnUrl }}
    >
      <LegacyCard>
        <SellsList page={page || 1} onCreateNewSell={() => newSellModal.current.open()} />
      </LegacyCard>
    </Page>
  </>;
};

export default Sells;
